import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  Col, Badge
} from "reactstrap";
import {
  getDispensedPrescriptions,
  presc_modal_view
} from "../../actions/mqttAction";

import PropTypes from "prop-types";
import { connect as con } from "react-redux";
import isEmpty from "lodash/isEmpty";
import { TablePagination } from "react-pagination-table";
import _ from "lodash";
import Spinner from "../common/Spinner";

class DispensedComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchList: [],
      search: false,
      searchTerm: "",
      to_load: true
    };
  }

  UNSAFE_componentWillMount() {
    this.props.getDispensedPrescriptions();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.mqtt.dispensed_loading) {
      this.setState({ to_load: true });
      return;
    }
    const list = nextProps.mqtt.dispensedPrescriptions || [];
    this.setState({ searchList: list, to_load: false });
    this.props.send_Dispense_length(list.length);
  }

  renderConsellingLabel(requireConsult) {
    let badge;
    if (requireConsult) {
      badge = (
        <Badge color="danger" pill className="ml-1">
          CounsellingRequired
        </Badge>
      );
    }
    return badge;
  }

  onSearch = e => {
    e.preventDefault();
    this.setState({ search: true });
    this.setState({ searchTerm: e.target.value.toLowerCase() }, () => {
      const filterDispensed = _.filter(
        this.props.mqtt.dispensedPrescriptions || [],
        dispensed =>
          dispensed.patientInfo.firstName
            .toLowerCase()
            .includes(this.state.searchTerm) ||
          dispensed.patientInfo.lastName
            .toLowerCase()
            .includes(this.state.searchTerm) ||
          dispensed.rxInfo.prescriptionNumber
            .toLowerCase()
            .includes(this.state.searchTerm)
      );
      this.setState({ searchList: filterDispensed });
    });
  };

  openModalView(dispensedPrescription) {
    let isView = true;
    let prescription = dispensedPrescription;
    let patientId = dispensedPrescription.patientInfo.patientId;
    let prescriptionNumber = dispensedPrescription.rxInfo.prescriptionNumber;
    this.props.presc_modal_view(
      isView,
      prescription,
      patientId,
      prescriptionNumber
    );
  }

  render() {
    let dispensedArray = [];
    this.state.searchList.map(dispensed => {
      let date = String(dispensed.updateAt).split(" ")[0];
      let time = String(dispensed.updateAt).split(" ")[1];
      dispensedArray.push({
        edit: (
          <Link to='#' onClick={() => this.openModalView(dispensed)}>
            <i
              className="text-success fas fa-thumbs-up"
              onClick={() => this.openModalView(dispensed)}
            />
          </Link>
        ),
        name: (
          <Link to='#' onClick={() => this.openModalView(dispensed)}>
            <span className="text-capitalize">
              <strong>
                {dispensed.patientInfo.firstName.toUpperCase()} {dispensed.patientInfo.lastName.toUpperCase()}
              </strong>
              {this.renderConsellingLabel(dispensed.patientInfo.patientAdditionalInfo.requireConsult)}

              <div className="text-info">
                {dispensed.patientInfo.dateOfBirth}
              </div>
            </span>
          </Link>
        ),
        prescription: (
          <Link to='#' onClick={() => this.openModalView(dispensed)}>
            <span>
              <strong>{dispensed.rxInfo.prescriptionNumber}</strong>
              <div className="text-info">{dispensed.rxInfo.rxName}</div>
            </span>
          </Link>
        ),
        branch: (
          <div>
            {isEmpty(dispensed.branchName) ? "N/A" : dispensed.branchName}
          </div>
        ),
        tab: <span>{dispensed.rxInfo.rxType}</span>,
        date: (
          <span>
            {date}
            <br></br>
            <span className="text-info">{time}</span>
          </span>
        )
      });
    });

    const dispensed = (
      <TablePagination
        data={dispensedArray}
        columns="edit.name.prescription.branch.tab.date"
        perPageItemCount={6}
        totalCount={this.state.searchList.length}
        arrayOption={[[]]}
        className={
          "text-center table table-borderless table-striped font-style"
        }
        paginationClassName={"react-paginate"}
      />
    );

    let disp = <Spinner />;
    if (!this.state.to_load) {
      disp = (
        <div>
          <div className="py-2">
            <Row>
              <Col></Col>
              <Col></Col>
              <Col>
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="fas fa-search" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    className="form-control"
                    placeholder="Search"
                    onChange={this.onSearch.bind(this)}
                  />
                </InputGroup>
              </Col>
            </Row>

            {dispensed}
          </div>
        </div>
      );
    }

    return disp;
  }
}

DispensedComponent.propTypes = {
  getDispensedPrescriptions: PropTypes.func.isRequired,
  mqtt: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  presc_modal_view: PropTypes.func.isRequired
};

const mapStateToProps = state => ({ mqtt: state.mqtt, auth: state.auth });

export default con(mapStateToProps, {
  getDispensedPrescriptions,
  presc_modal_view
})(DispensedComponent);
